import { ActivityKind } from '../constants';
import createActivity from './createActivity';
import { ThunkResult } from '../../../stores/types';
import getShippingLabelToPrint from './getShippingLabelToPrint';

export default function printLabel(): ThunkResult<Promise<void>> {
  return function printLabelEffects(dispatch): Promise<void> {
    return dispatch(getShippingLabelToPrint()).then((res) => {
      if (res) {
        dispatch(createActivity({
          kind: ActivityKind.PRINT_LABEL,
          organizationId: res.organizationId,
          orderNumber: res.orderNumber,
        }));
        window.open(res.label.label?.pdf, '_blank');
      }
    });
  };
}
